import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturMondsee() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-mondsee-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-mondsee-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="mondsee" />
      </div>
    </div>
  );
}

export default BodentemperaturMondsee;
